import classes from "./PageContent.module.css";

function PageContent({ title, subTitle, children }) {
  return (
    <div className={classes.content}>
      <h1>{title}</h1>
      <p>{subTitle}</p>
      {children}
    </div>
  );
}

export default PageContent;
